import { Component } from '@angular/core';
import { Branches, Province } from './branch';

@Component({
  selector: 'app-branch-selector',
  standalone: true,
  imports: [],
  templateUrl: './branch-selector.component.html',
  styleUrl: './branch-selector.component.scss'
})
export class BranchSelectorComponent {
  
  provinces: Province[] = Branches;

  toggleProvince(province: Province) {
    this.provinces.forEach(p => {
      if (p !== province) p.active = false;
    });
    province.active = !province.active;
  }
}
